export default "__VITE_ASSET__DYXa6EyV__"